export default __webpack_public_path__ + "static/media/IMG_20210725_155644_421.0ee0e49b.jpg";